import { faBus, faFilter } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Divider,
  Drawer,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select
} from '@material-ui/core';
import { Button } from '@vadiun/react-components';
import React, { FunctionComponent, useState } from 'react';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { BusType } from '../../viajeTraslado/models/TransferReservation';

type Props = {
  filters: Record<string, string | number | null | undefined | number[]>;
  optionsBuses: BusType[];
  onSubmitFilters: (filters: any) => Promise<void>;
};

const SchemaFilters = Yup.object().shape({
  bus_type_id: Yup.array(Yup.number()).nullable()
});

const FiltersStatsBuses: FunctionComponent<Props> = ({
  filters,
  optionsBuses,
  onSubmitFilters
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        variant="outlined"
        className="h-fit"
        onClick={() => setOpen(true)}
      >
        <FontAwesomeIcon icon={faFilter} />
      </Button>

      <Drawer
        variant="persistent"
        anchor="right"
        open={open}
        onClose={() => setOpen(false)}
        className="max-w-md"
      >
        <div className="h-full">
          <IconButton onClick={() => setOpen(false)}>
            <ChevronRightIcon />
          </IconButton>
          <Divider />
          <div style={{ padding: '1rem', width: '25dvw', height: '95dvh' }}>
            <Formik
              initialValues={{ bus_type_id: filters.bus_type_id }}
              validationSchema={SchemaFilters}
              onSubmit={onSubmitFilters}
              enableReinitialize
            >
              {({ submitForm, touched, errors, values, setFieldValue }) => (
                <Form className="w-full h-full flex flex-col">
                  <FormControl
                    variant="outlined"
                    fullWidth
                    className="col-span-1"
                  >
                    <InputLabel id="bus-type-label">Tipo de bus</InputLabel>
                    <Select
                      multiple
                      value={values.bus_type_id || []}
                      name="bus_type_id"
                      labelId="bus-type-label"
                      label="Tipo de bus"
                      displayEmpty
                      onChange={(e) => {
                        setFieldValue('bus_type_id', e.target.value);
                      }}
                      renderValue={(selected: any) => {
                        if (selected.length === 0) {
                          return <em>Seleccione un bus</em>;
                        }
                        return (
                          <div className="grid grid-cols-2 gap-1">
                            {optionsBuses
                              .filter(({ id }) => selected.includes(id))
                              .map(({ name }) => (
                                <span
                                  key={name}
                                  className="text-sm text-gray-800 bg-gray-200 w-fit px-2 py-1 rounded-full"
                                >
                                  {name}
                                </span>
                              ))}
                          </div>
                        );
                      }}
                    >
                      {optionsBuses.map(({ id: key, name }) => (
                        <MenuItem value={key} key={key}>
                          <div className="flex items-center w-full">
                            <div className="w-6">
                              <FontAwesomeIcon
                                icon={faBus}
                                color="#8EC3E6"
                                size="1x"
                              />
                            </div>
                            <p className="m-0">{name}</p>
                          </div>
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <Button
                    variant="contained"
                    className="w-fit ml-auto mt-auto"
                    onClick={submitForm}
                  >
                    Filtrar
                  </Button>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </Drawer>
    </>
  );
};

export default FiltersStatsBuses;
